/* Clube VIP Laleblu - fechar a confirmacao com a tecla Esc (melhoria opcional) */
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var toggle = document.getElementById('lp-vip-fechado');
    if (toggle && !toggle.checked) toggle.checked = true;
  });
})();
